import { render, staticRenderFns } from "./NewsCenterDetails2.vue?vue&type=template&id=2e016607&scoped=true"
import script from "./NewsCenterDetails2.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails2.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails2.vue?vue&type=style&index=0&id=2e016607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e016607",
  null
  
)

export default component.exports